import Grid from "../../../../common/table";
import React, {useContext, useEffect, useState} from "react";
import server from "../../../../server";
import { Button, Dropdown, Form, Input, message, Modal, Popconfirm, Select, Tag, Tooltip } from "antd";
import {getName, removeUnderScore} from "../../../../utility/utility";
import {IAllocateAssetsFormData} from "../../../employee-detail/types/asset.types";
import AssetRejectModal from "../../../employee-detail/component/utils/asset-reject-modal";
import AssetAllocateModal from "../../../employee-detail/component/utils/asset-allocate-modal";
import {allocateAssetModalMapper} from "../../../employee-detail/component/actions/asset.action";
import EmployeeAvatar from "../../../employee/avatar/employee-avatar";
import {AssetAllocationStatus} from "../../../../domains/models/asset-management/asset-allocation";
import SearchCriteria from "../../../common/search-criteria/search-criteria";
import {Search_Asset_Request_Status} from "../../../../constant/constant";
import {SearchParams} from "../../../common/search-criteria/type/search-criteria.type";
import EmployeeOverviewPopover from "../../../employee/overview/employee-overview-popover/employee-overview-popover";
import {IAssetRequestState} from "./type/asset-requests.types";
import UserLoginContext from "../../../../context/userLoginContext";
import AssetRequestModal from "../../../employee-detail/component/utils/asset-request-modal";
import { CircleCheck, CircleX, Ellipsis, Share2 } from "lucide-react";
import LoadingSkeleton from "../../../common/loading-skeleton/loading-skeleton";
import '../../../../styles/component/asset/asset-request.scss';


const AssetRequest = () => {
    const [pageNumber, setPageNumber] = useState(0);
    const [assetRejectForm] = Form.useForm();
    const [assetAllocateForm] = Form.useForm();
    const [assetRequestForm] = Form.useForm();
    const {user} = useContext(UserLoginContext);
    const [loading, setLoading] = useState(true);
    const [state, setState] = useState<IAssetRequestState>({
        modal: {
            reject: false,
            allocate: false,
            assetRequest: false,
        },
        data: {
            assetRequests: [],
            categories: []
        },
        selected: {
            RequestId: "",
            AllocateRecord: null
        },
        searchPayload: {
            status: [AssetAllocationStatus.REQUESTED, AssetAllocationStatus.REQUEST_ACCEPTED]
        }
    })
    const pageSize = 10;

    const handleNextPage = () => {
        setPageNumber(prev => prev + 1);
    };

    const handlePrevPage = () => {
        if (pageNumber > 0) {
            setPageNumber(prev => prev - 1);
        }
    };

    useEffect(() => {
        fetchAssetCategories();
    }, [])



    const payload = {
        status: [AssetAllocationStatus.REQUEST_CANCELLED, AssetAllocationStatus.REQUEST_REJECTED, AssetAllocationStatus.REQUESTED, AssetAllocationStatus.REQUEST_ACCEPTED]
    }

    useEffect(() => {
        if (user.isAdmin) {
            getAllAssetRequest(state.searchPayload, pageNumber);

        } else {
            getAllAssetRequest(payload, pageNumber)
        }
    }, [state.searchPayload, pageNumber])


    async function fetchAssetCategories() {
        try {
            const categories = await server.asset.category.list();
            setState((prev) => ({
                ...prev,
                data: {
                    ...prev.data,
                    categories: categories
                }
            }))
        } catch (e) {
            console.log("Error while fetching categories", e);
        }
    }

    const handleAssetRequestSearch = (params: SearchParams) => {
        let statusPayload;
        if (!params.status) {
            statusPayload = [AssetAllocationStatus.REQUESTED];
        } else if (params.status === "ALL") {
            statusPayload = [
                AssetAllocationStatus.REQUESTED,
                AssetAllocationStatus.REQUEST_CANCELLED,
                AssetAllocationStatus.REQUEST_REJECTED,
                AssetAllocationStatus.REQUEST_ACCEPTED
            ];
        } else {
            statusPayload = [params.status];
        }

        const payload: any = {
            employeeName: params.employeeName,
            categoryId: params.categoryId,
            status: statusPayload
        }
        setState((prev) => ({
            ...prev,
            searchPayload: payload
        }))
        setPageNumber(0);
        getAllAssetRequest(payload, 0);
    }

    const handleAssetRequestSearchReset = () => {
        const defaultPayload = {
            status: [AssetAllocationStatus.REQUESTED, AssetAllocationStatus.REQUEST_ACCEPTED]
        };

        setState((prev) => ({
            ...prev,
            searchPayload: defaultPayload
        }))

        setPageNumber(0);
        getAllAssetRequest(defaultPayload, 0);
    }

    async function handleCancelRequest(record: any) {
        const payload = {
            status: [AssetAllocationStatus.REQUESTED, AssetAllocationStatus.REQUEST_ACCEPTED]
        }
        try {
            await server.asset.request.cancel(record.id);
            getAllAssetRequest(payload, 0)
            message.success("Request cancelled successfully!")
        } catch (e) {
            console.log("Error while cancelling request", e);
        }
    }

    const handleRejectModal = () => {
        setState((prev) => ({
            ...prev,
            modal: {
                ...prev.modal,
                reject: true
            }
        }))
    }

    const handleRejectModalClose = () => {
        assetRejectForm.resetFields();
        setState((prev) => ({
            ...prev,
            modal: {
                ...prev.modal,
                reject: false
            },
            selected: {
                ...prev.selected,
                RequestId: ""
            }
        }))
    }

    const handleAssetRequestModal = () => {
        assetRequestForm.resetFields();
        setState((prev) => ({
            ...prev,
            modal: {
                ...prev.modal,
                assetRequest: true
            }
        }))
    }


    const handleAssetRequestModalClose = () => {
        assetRequestForm.resetFields();
        setState((prev) => ({
            ...prev,
            modal: {
                ...prev.modal,
                assetRequest: false
            }
        }))
    }


    async function handleAssetRequestSubmit() {
        try {
            const values = await assetRequestForm.validateFields();
            const categoryId = values.categoryId;
            await server.asset.request.create(categoryId, values.employeeRemarks);
            message.success("Asset request submitted successfully!");
            getAllAssetRequest(payload, pageNumber)
            handleAssetRequestModalClose();
        } catch (error) {
            message.error("Failed to submit request");
        }
    }


    const handleAllocateAssetModal = () => {
        setState((prev) => ({
            ...prev,
            modal: {
                ...prev.modal,
                allocate: true
            }
        }))
    }

    const handleAssetAllocateModalClose = () => {
        assetAllocateForm.resetFields();
        setState((prev) => ({
            ...prev,
            modal: {
                ...prev.modal,
                allocate: false
            },
            selected: {
                ...prev.selected,
                AllocateRecord: null
            }
        }))
    }

    async function handleRejectionSubmit() {
        try {
            const formValues = await assetRejectForm.validateFields();
            await server.asset.request.reject(state.selected.RequestId, formValues.rejectMessage);
            message.success("Request rejected successfully!");
            await getAllAssetRequest(state.searchPayload, 0);
            handleRejectModalClose();
            setState((prev) => ({
                ...prev,
                selected: {
                    ...prev.selected,
                    RequestId: ""
                }
            }))
        } catch (e) {
            console.log("Error while rejecting request", e)
        }
    }

    async function handleAssetAllocateSubmit(formValues: IAllocateAssetsFormData) {
        const payload = allocateAssetModalMapper(formValues);
        if (!state.selected.AllocateRecord?.id) {
            return;
        }
        try {
            await server.asset.allocate(state.selected.AllocateRecord?.id, payload);
            message.success("Asset allocated successfully!");
            await getAllAssetRequest(state.searchPayload, 0);
            handleAssetAllocateModalClose();
        } catch (e) {
            console.log("Error while submitting leave", e);
        }
    }

    async function getAllAssetRequest(payload: any, pageNumber: number) {
        setLoading(true);
        try {
            const allAssetRequests = await server.asset.allocation.search(pageNumber, pageSize, payload);
            setState((prev) => ({
                ...prev,
                data: {
                    ...prev.data,
                    assetRequests: allAssetRequests,
                }
            }))
        } catch (e) {
            console.log('Error while fetching requests', e);
        } finally {
            setLoading(false)
        }
    }

    async function handleApproveRequest(record: any) {
        try {
            await server.asset.request.approve(record.id);
            message.success("Request approved successfully!");
            await getAllAssetRequest(state.searchPayload, 0);
        } catch (e) {
            console.log("Error while approving request", e);
        }
    }

    const columns = [
        ...(user?.isAdmin ? [
            {
                title: "Employee Name",
                dataIndex: "employeeProfile",
                key: "employeeProfile",
                render: (_: any, record: any) => {
                    return (
                        <div className="employee-name-wrapper">
                            <EmployeeAvatar
                                name={{
                                    firstName: record?.employeeProfile?.name?.firstName,
                                    lastName: record?.employeeProfile?.name?.lastName
                                }}
                                thumbnailId={record?.employeeProfile?.profileThumbnailId}
                                size={25}
                            />
                            <EmployeeOverviewPopover
                                employeeId={record.employeeProfile.id}
                                uniqueKey={`${record?.employeeProfile?.id}-${record.id}`}
                            >
                                <div className="employee-search-table-name">
                                    {getName(record.employeeProfile.name.firstName, record.employeeProfile.name.middleName, record.employeeProfile.name.lastName)}
                                </div>
                            </EmployeeOverviewPopover>
                        </div>
                    );
                }
            }
        ] : []),
        {
            title: "Category Name",
            dataIndex: "assetCategory",
            key: "assetCategory",
            render: (_: any, record: any) => {
                return record?.assetCategory?.name ? record.assetCategory.name : "-"
            }
        },
        {
            title: "Employee Remarks",
            dataIndex: "employeeRemarks",
            key: "employeeRemarks",
            render: (_: any, record: any) => {
                return record?.employeeRemarks ? record?.employeeRemarks : "-"
            }
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (_: any, record: any) => {
                return <Tag className={`asset-allocation-status ${record.status.toLowerCase()}`}>
                    {record?.status ? removeUnderScore(record.status) : "-"}
                </Tag>
            }
        },
        {
            title: "Actions",
            dataIndex: "actions",
            key: "actions",
            width:'5%',
            render: (_: any, record: any) => {
                const isAdmin=user.isAdmin;
                const isDisabled = record.status !== 'REQUESTED';

                const menuItems=[
                    {
                        key:0,
                        label:'Approve',
                        icon:<CircleCheck
                            className={`action-approve 
                            ${record.status !== 'REQUESTED' ? 'action-disabled' : ''}`}/>,
                        onClick:()=>{
                            Modal.confirm({
                                title:'Confirmation',
                                content:'Are you sure to approve request?',
                                okText:'Yes',
                                onOk:() => handleApproveRequest(record)
                            })
                        },
                        disabled:record.status !== 'REQUESTED'
                    },
                    {
                        key:1,
                        label:'Allocate',
                        icon: <Share2
                            className={`action-assign action-add 
                            ${record.status !== "REQUEST_ACCEPTED" ?
                                'action-disabled' : ''}`}/>,
                        onClick:()=>{
                            handleAllocateAssetModal();
                            setState((prev) => ({
                                ...prev,
                                selected: {
                                    ...prev.selected,
                                    AllocateRecord: record
                                }
                            }))
                        },
                        disabled:record.status !== "REQUEST_ACCEPTED"
                    },
                    {
                        key:2,
                        label:'Reject',
                        icon: <CircleX
                            className={`action-reject action-danger 
                            ${record?.status != "REQUESTED" ? 'action-disabled' : ''}`}/>,
                        onClick:()=>{
                            setState((prev) => ({
                                ...prev,
                                selected: {
                                    ...prev.selected,
                                    RequestId: record.id
                                }
                            }))
                            handleRejectModal();
                        }
                    },
                ]

                return (
                    isAdmin?
                   ( <Dropdown menu={{items: menuItems}} overlayClassName={'pn-table-action-menu'}>
                        <Ellipsis className={'pn-table-actions-icon'}/>
                    </Dropdown>)
                        :
                        (
                            <div className={'pn-table-actions'}>
                                <Tooltip title={"Cancel Request"}>
                                    <Popconfirm title={"Are you sure to cancel request?"}
                                                okText={"Yes"}
                                                onConfirm={() => handleCancelRequest(record)}>
                                        <CircleX
                                            className={`action-reject ${isDisabled ? 'action-disabled' : ''}`}/>
                                    </Popconfirm>
                                </Tooltip>
                            </div>
                        )
                )
            }
        }
        ]


    return (
        <div className={'asset-request'}>
            <div className={'asset-request-tab-header'}>
                {user?.isAdmin ? <h1 className={'asset-request heading'}>Asset Requests </h1> :
                    <h1 className={'asset-request heading'}>Requested Assets </h1>
                }
                {
                    !user?.isAdmin &&
                    <Button type={"primary"} onClick={handleAssetRequestModal}>+ Request Asset</Button>
                }
            </div>

            {user?.isAdmin && <SearchCriteria
                title={"Search Asset Requests"}
                onSearch={handleAssetRequestSearch}
                onReset={handleAssetRequestSearchReset}
                showReset={true}
                renderTopContent={({values, onChange}) => (
                    <>
                        <div>
                            <label className={"label"}> Name</label>
                            <Input
                                placeholder="Enter Name"
                                value={values.employeeName || ''}
                                onChange={(e) => onChange('employeeName', e.target.value)}
                            />
                        </div>

                        <div>
                            <label className={"label"}>Select Category</label>
                            <Select
                                placeholder={"Select Category"}
                                onChange={(val: any) => onChange('categoryId', val)}
                                value={values.categoryId}
                                allowClear
                                className={"label"}
                            >
                                {state.data.categories.map((item: any) => (
                                    <Select.Option key={item.id} value={item.id}>
                                        {item.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </div>

                        <div>
                            <label className={"label"}>Select Status</label>
                            <Select
                                placeholder={"Select Asset Status"}
                                onChange={(val: any) => onChange('status', val)}
                                value={
                                    values.status ?? [
                                        AssetAllocationStatus.REQUESTED,
                                        AssetAllocationStatus.REQUEST_ACCEPTED
                                    ]
                                }
                                allowClear
                                dropdownStyle={{width: 'max-content'}}
                            >
                                <Select.Option key="ALL" value="ALL">
                                    Select All
                                </Select.Option>
                                {(Object.keys(Search_Asset_Request_Status) as Array<keyof typeof Search_Asset_Request_Status>).map((key) =>
                                    <Select.Option value={key} key={key}>
                                        {Search_Asset_Request_Status[key]}
                                    </Select.Option>
                                )}
                            </Select>
                        </div>
                    </>
                )}
            />
            }

            <div className={'asset-requests-table'}>
                <LoadingSkeleton loading={loading}>
                    <Grid
                        bordered={true}
                        paginationButton={true}
                        pageSize={pageSize}
                        handleNextPage={handleNextPage}
                        handlePrevPage={handlePrevPage}
                        pageNumber={pageNumber}
                        dataSource={state.data.assetRequests}
                        columns={columns}
                    />
                </LoadingSkeleton>
            </div>

            <AssetRejectModal
                assetRejectModal={state.modal.reject}
                handleRejectModalClose={handleRejectModalClose}
                assetRejectForm={assetRejectForm}
                handleRejectionSubmit={handleRejectionSubmit}
            />

            <AssetRequestModal
                assetRequestModal={state.modal.assetRequest}
                handleAssetRequestModalClose={handleAssetRequestModalClose}
                assetRequestForm={assetRequestForm}
                assetCategoryData={state.data.categories}
                handleAssetRequestSubmit={handleAssetRequestSubmit}
            />

            <AssetAllocateModal
                assetAllocateForm={assetAllocateForm}
                selectedAssetAllocatedRecord={state.selected.AllocateRecord}
                assetAllocateModal={state.modal.allocate}
                handleAssetAllocateModalClose={handleAssetAllocateModalClose}
                handleAssetAllocateSubmit={handleAssetAllocateSubmit}
            />
        </div>
    )
}

export default AssetRequest;
